import { useMutation } from '@redwoodjs/web'

import { useCurrentUser } from '../../auth/useCurrentUser'

import { LocalView, saveLocalView } from './localViews'

const SAVE_MUTATION = gql`
  mutation SaveMutation($itListId: Int!) {
    saveView(itListId: $itListId)
  }
`
export function useSaveView() {
  const [saveView] = useMutation<number, { itListId: number }>(SAVE_MUTATION)
  const { id: sessionId } = useCurrentUser()
  if (sessionId) {
    return async (viewedItList: LocalView) => {
      const itListId = viewedItList.itListId
      await saveView({ variables: { itListId } })
    }
  }
  return saveLocalView
}
